module.exports = __webpack_public_path__ + "img/US-UK_Apple_Music_Listen_on_Lockup_all-blk_100617.7bd69ba7.svg";